import * as React from 'react';
import styles from './RadioButton.module.scss';

interface Props {
  name?: string;
  title?: string;
  checked?: boolean;
  defaultChecked?: boolean;
  value?: string | number;
  className?: string;
  disabled?: boolean;
  onClick?: (e: React.MouseEvent<HTMLInputElement>) => void;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
}

export const RadioButton = React.forwardRef<HTMLInputElement, Props>(
  function RadioButton(props, ref) {
    const id =
      props.name != undefined
        ? `uni-radio-${props.name}-${props.value}`
        : undefined;
    return (
      <div className={props.className}>
        <input
          type="radio"
          id={id}
          ref={ref}
          name={props.name}
          value={props.value}
          readOnly={!props.onClick && !props.onChange}
          className={styles.radio}
          checked={props.checked}
          defaultChecked={props.defaultChecked}
          disabled={props.disabled}
          onClick={props.onClick}
          onChange={props.onChange}
        />
        <label className={styles.label} htmlFor={id}>
          <span title={props.title}>{props.title}</span>
        </label>
      </div>
    );
  },
);
